'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = Checkable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _Functions = require('../core/Functions');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox/radio inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * @param {JSX.Component} Component
 * @returns {JSX.Component} A component with defaultable `checked` prop
 */
function Checkable(Component) {
  var CheckableComponent = function (_React$Component) {
    _inherits(CheckableComponent, _React$Component);

    function CheckableComponent(props) {
      _classCallCheck(this, CheckableComponent);

      var _this = _possibleConstructorReturn(this, (CheckableComponent.__proto__ || Object.getPrototypeOf(CheckableComponent)).call(this, props));

      _this.state = { checked: props.defaultChecked };
      _this.handleChange = _this.handleChange.bind(_this);
      _this._refCallback = (0, _utils.makeDecoratorRefCallback)(Component, _this);
      return _this;
    }

    _createClass(CheckableComponent, [{
      key: 'handleChange',
      value: function handleChange(evt) {
        var onChange = this.props.onChange;

        this.setState({ checked: evt.target.checked });
        (0, _Functions.callIfPossible)(onChange, evt);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            checked = _props.checked,
            __onChange = _props.onChange,
            rest = _objectWithoutProperties(_props, ['checked', 'onChange']);

        return _react2.default.createElement(Component, _extends({}, rest, {
          checked: checked != null ? checked : this.state.checked,
          onChange: this.handleChange,
          ref: this._refCallback
        }));
      }
    }]);

    return CheckableComponent;
  }(_react2.default.Component);

  CheckableComponent.propTypes = _extends({}, Component.propTypes, {
    checked: _react.PropTypes.bool,
    defaultChecked: _react.PropTypes.bool,
    onChange: _react.PropTypes.func
  });

  CheckableComponent.defaultProps = _extends({}, Component.defaultProps, {
    defaultChecked: Component.defaultProps && Component.defaultProps.checked != null ? Component.defaultProps.checked : false
  });
  delete CheckableComponent.defaultProps.checked;

  CheckableComponent.displayName = 'Checkable(' + (0, _getComponentName2.default)(Component) + ')';

  (0, _utils.attachWrappedComponent)(CheckableComponent, Component);

  return CheckableComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/decorators/Checkable.js
// module id = 369
// module chunks = 3 4 5